import register from '../../../../global/js/registry';
export default register(
	'm-professional-product-table-desktop',
	() => import(/* webpackMode: "lazy" */ './m-professional-product-table-desktop.controller'),
);
